// @core/api/endpoints/task/delete_status_definition.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete status definition
 * Deletes a custom status definition. Tasks using this status will retain their current value but the status will no longer be selectable.
 */
export async function DeleteStatusDefinition(
  status_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/status-definitions/:status_id`;
  requestPath = requestPath.replace(':status_id', encodeURIComponent(status_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
